import './main.css';
import { Link } from "react-scroll";
import React from 'react';
import creative from '../../img/main/creative.png'
import {InlineShareButtons} from 'sharethis-reactjs';
import ReactPlayer from "react-player";
import main_video from '../../videos/main.mp4'
import video_preview from "../../img/preview.png";

export default class Main extends React.Component {
    render() {
        return (
            <div className='main_wrap'>
                <div className='container main_block'>
                    <div className='main_content main_item'>
                        <h1 className='main_title'><span className='main_title--small'>Global Summit</span><br/>for Node.js'22</h1>
                        <p className='main_descr main_descr-data'>May 18, 2022 - Junior Track</p>
                        <p className='main_descr'>May 19, 2022 - Senior Track</p>
                        <div className='main_btns_wrap'>
                            <Link
                            activeClass="active"
                            to='tickets'
                            spy={true}
                            smooth={true}
                            offset={80}
                            className='main_btn main_btn--first'
                            >
                            GET TICKET
                            </Link>
                            <InlineShareButtons
                                className='main_button main_btn--share'
                                config={{
                                alignment: 'center',  // alignment of buttons (left, center, right)
                                color: 'transparent',      // set the color of buttons (social, white)
                                enabled: true,        // show/hide buttons (true, false)
                                font_size: 16,        // font size for the buttons
                                labels: 'cta',        // button labels (cta, counts, null)
                                language: 'en',       // which language to use (see LANGUAGES)
                                networks: [           // which networks to include (see SHARING NETWORKS)
                                    'sharethis'
                                ],
                                padding: 12,          // padding within buttons (INTEGER)
                                radius: 0,            // the corner radius on each button (INTEGER)
                                size: 49,             // the size of each button (INTEGER)

                                // OPTIONAL PARAMETERS
                                url: 'https://events.geekle.us/nodejs/?utm_source=website&utm_medium=sharelink', // (defaults to current url)
                                description: 'Anything, that you have to know about Node.js in 2022',       // (defaults to og:description or twitter:description)
                                title: `Global Summit for NODE JS'22`,            // (defaults to og:title or twitter:title)
                                }}
                            />
                        </div>
                    </div>
                    {/* <div className='main_img_block main_item'>
                        <img className='main_img' src={creative} alt="" />
                    </div> */}
                    <div className="main_video main_item">
                        {/* <video
                        preload={"auto"}
                        // autoPlay={true}
                        loop={true}
                        muted={"muted"}
                        playsInline
                        >
                        <source src={video_vue} type="video/mp4" />
                        </video> */}
                        <ReactPlayer
                        url={main_video}
                        width="100%"
                        height="auto"
                        playing
                        controls
                        playIcon={<button className='videoPresent_item-play'></button>}
                        light={video_preview}
                        />
                    </div>
                </div>
            </div>
        )
    }
}